import apiClient from './axios';
import type { AuditLog, AuditLogListParams, AuditLogsListResponse } from '@cms/models';

export type AuditLogsListParams = AuditLogListParams;
export type { AuditLogsListResponse };

export const auditLogApi = {
  getPaginated: async (params: AuditLogsListParams = {}): Promise<AuditLogsListResponse> => {
    const {
      page = 1,
      pageSize = 25,
      search,
      userId,
      entityType,
      entityId,
      action,
      fromDate,
      toDate,
      sortBy,
      sortOrder,
    } = params;
    const response = await apiClient.get<AuditLogsListResponse>('/audit-logs', {
      params: {
        page,
        pageSize,
        ...(search ? { search } : {}),
        ...(userId ? { userId } : {}),
        ...(entityType ? { entityType } : {}),
        ...(entityId ? { entityId } : {}),
        ...(action ? { action } : {}),
        ...(fromDate ? { fromDate } : {}),
        ...(toDate ? { toDate } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(sortOrder ? { sortOrder } : {}),
      },
    });
    return response.data;
  },

  getById: async (id: string): Promise<AuditLog> => {
    const response = await apiClient.get<AuditLog>(`/audit-logs/${id}`);
    return response.data;
  },
};
